export type EmployeeSubproductRailKey = 'experience' | 'aifi' | 'roi';

const EMPLOYEE_SUBPRODUCT_RAIL_LABELS: Record<EmployeeSubproductRailKey, string> = {
  experience: 'Experience',
  aifi: 'Proficiency',
  roi: 'ROI',
};

export function getEmployeeSubproductRailKeys(
  _isProficiencyEnabled: boolean,
  _isRoiEnabled: boolean,
): EmployeeSubproductRailKey[] {
  return ['experience', 'aifi', 'roi'];
}

export function getEmployeeSubproductRailLabels(
  isProficiencyEnabled: boolean,
  isRoiEnabled: boolean,
): string[] {
  return getEmployeeSubproductRailKeys(isProficiencyEnabled, isRoiEnabled).map(
    (key) => EMPLOYEE_SUBPRODUCT_RAIL_LABELS[key],
  );
}
